import React from 'react';
import Courses from '../Courses/Courses';

const CoursePage = () => {
    return (
        <div>
            <h2 className="text-5xl p-4 section-title">Our award winning courses</h2>
            <Courses />
        </div>
    );
};

export default CoursePage;